import FitText from '@kennethormandy/react-fittext'
import slugify from '@sindresorhus/slugify'
import { Button } from 'antd'
import React from 'react'
import { Link } from 'react-static'
import styled from 'styled-components'
import { lighten } from 'polished'
import { Cell, Flex } from '../styles/styled-common'
import {
  currencySymbolByCode,
  localeCompareFunc,
  getControlPanelFromHost,
} from '../utils'
import {
  ControlPanelCell,
  CustomerSupportCell,
  LocationsCell,
  PlatformsCell,
  ProviderCell,
  RatingCell,
  SlotsCell,
} from './cells'

const ActionButton = styled(Button)`
  padding: 0 10%;
  width: 100%;
  height: auto;
  padding-top: 5px;
  padding-bottom: 5px;
  border: none;
  font-family: 'Saira';
`

const SecondaryButton = styled(ActionButton)`
  background: ${p => p.theme.buttonSecondary};

  &:hover {
    background: ${p => lighten(0.1, p.theme.buttonSecondary)};
  }
  margin-top: 10px;
`

export default [
  {
    title: 'Host',
    columnKey: 'host',
    sorter: localeCompareFunc('name'),
    layout: { span: 3 },
    mobile: { span: 24 },
    render: ({ affiliateUrl, id, logo, name }, mobile = false) => (
      <ProviderCell
        affiliateUrl={affiliateUrl}
        id={id}
        logo={logo}
        name={name}
        style={mobile ? { height: 'auto' } : null}
        fitText={!mobile}
      />
    ),
  },
  {
    title: 'TrustPilot Ratings',
    columnKey: 'ratings',
    sorter: (a, b) => {
      const diff = (a.ratings.score || 0) - (b.ratings.score || 0)

      if (diff !== 0) return diff

      return (a.ratings.reviewCount || 0) - (b.ratings.reviewCount || 0)
    },
    layout: { span: 3 },
    mobile: { span: 24 },
    render: ({ ratings, affiliateUrl }, mobile = false) =>
      !ratings || !ratings.score ? (
        <Flex style={{ textAlign: 'center', height: '100%' }}>N/A</Flex>
      ) : (
        <RatingCell
          rating={ratings}
          affiliateUrl={affiliateUrl}
          // fitText={!mobile}
          style={mobile ? { height: 'auto' } : null}
        />
      ),
  },
  {
    title: 'Locations',
    columnKey: 'locations',
    layout: { span: 4 },
    mobile: { span: 12 },
    render: ({ gameInfo: { locations }, baseCurrency }, mobile = false) => (
      <LocationsCell
        justifyContent="start"
        currency={baseCurrency}
        locations={locations}
        style={mobile ? { height: 'auto' } : null}
      />
    ),
  },
  {
    title: 'Supported Platforms',
    columnKey: 'platforms',
    layout: { span: 2 },
    mobile: { span: 12 },
    render: ({ gameInfo: { platforms } }, mobile = false) => (
      <PlatformsCell
        platforms={platforms}
        style={mobile ? { height: 'auto' } : null}
      />
    ),
  },
  {
    title: 'Capacity',
    columnKey: 'slots',
    mobile: { span: 12 },
    sorter: (a, b) => (a.gameInfo.slots.min || 0) - (b.gameInfo.slots.min || 0),
    layout: { span: 2 },
    render: ({ gameInfo: { slots } }, mobile = false) => (
      <SlotsCell
        slots={slots}
        style={{ textAlign: 'center', height: mobile && 'auto' }}
      />
    ),
  },
  {
    title: 'Price',
    columnKey: 'price',
    sorter: (a, b) => a.gameInfo.price.min - b.gameInfo.price.min,
    layout: { span: 2 },
    mobile: { span: 12 },
    render: ({ baseCurrency, gameInfo: { price } }, mobile = false) => (
      <Cell
        justifyContent="center"
        flexDirection="column"
        style={{ textAlign: 'center', height: mobile && 'auto' }}
      >
        <div>
          {currencySymbolByCode(baseCurrency)}
          {price.min === price.max
            ? `${price.min.toFixed(2)}`
            : `${price.min.toFixed(2)}-${price.max.toFixed(2)}`}{' '}
          / slot
        </div>
        {/* <div>per slot</div> */}
      </Cell>
    ),
  },
  {
    title: 'Control Panel',
    columnKey: 'controlPanel',
    layout: { span: 3 },
    render: (host, mobile = false) => {
      const { screenshots, type } = getControlPanelFromHost(host)

      return (
        <ControlPanelCell
          screenshots={screenshots}
          type={type}
          style={mobile ? { height: 'auto' } : null}
        />
      )
    },
  },
  {
    title: 'Customer Support',
    columnKey: 'customerSupport',
    layout: { span: 2 },
    render: ({ customerSupport }, mobile = false) => (
      <CustomerSupportCell
        support={customerSupport}
        style={mobile ? { height: 'auto' } : null}
      />
    ),
  },
  {
    columnKey: 'actions',
    layout: { span: 3 },
    mobile: { span: 24 },
    render: ({ id, name }, mobile = false) => (
      <Cell flexDirection="column" style={mobile ? { height: 'auto' } : null}>
        <Link to={`/hosts/${slugify(name)}`} style={{ width: '100%' }}>
          <ActionButton type="primary" size="large">
            <FitText compressor={0.6} maxFontSize={30}>
              More Info
            </FitText>
          </ActionButton>
        </Link>
        <a
          style={{ width: '100%' }}
          href={`/go/${id}`}
          target="_blank"
          rel="nofollow noopener"
        >
          <SecondaryButton type="primary" size="large">
            <FitText compressor={0.6} maxFontSize={30}>
              Buy
            </FitText>
          </SecondaryButton>
        </a>
      </Cell>
    ),
  },
]



// WEBPACK FOOTER //
// /opt/build/repo/src/components/HostsListColumns.jsx